import { ReactNode, useState } from 'react';

import { scale } from '@scripts/gds';
import { useMedia } from '@scripts/hooks';
import { themeColor } from '@scripts/themes/cssVars';

const Heading = ({ children }: { children?: ReactNode }) => {
    const { sm } = useMedia();
    const [isLiked, setIsLiked] = useState<boolean>(false);

    return (
        <div
            css={{
                display: 'flex',
                alignItems: 'center',
                gap: scale(2),
                [sm]: {
                    justifyContent: 'space-between',
                },
            }}
        >
            <h1
                css={{
                    fontSize: '32px',
                    lineHeight: '120%',
                    letterSpacing: 0,
                    color: themeColor.textBlack,
                    fontWeight: 500,
                }}
            >
                {children}
            </h1>
        </div>
    );
};

export default Heading;
